import { EnhancedWithAuthHttpService } from './http-auth.service'
import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'

import {
  ICreateApprovalFeedbacksDto,
  IMessageResponseDto,
  IApprovalFeedbacksRespDto,
  IUpdateApprovalFeedbacksDto,
  IApprovalFeedbacksBaseWithId,
} from 'src/types'

class ApprovalFeedbacksService extends EnhancedWithAuthHttpService {
  constructor() {
    super(new HttpService(axiosInstance))
  }

  getApprovalFeedbacks(params?: {}) {
    return this.get<IApprovalFeedbacksRespDto>('approval-feedbacks/', { params })
  }

  getApprovalFeedbacksOptions() {
    return this.get<IApprovalFeedbacksBaseWithId[]>('approval-feedbacks/options', {})
  }

  getApprovalFeedbacksByIds(ids: string[]) {
    return this.get<IApprovalFeedbacksBaseWithId[]>('approval-feedbacks/ids', { params: { ids } })
  }

  createApprovalFeedback(dto: ICreateApprovalFeedbacksDto) {
    return this.post<IMessageResponseDto, ICreateApprovalFeedbacksDto>('approval-feedbacks/', dto)
  }

  updateApprovalFeedback(id: string, dto: IUpdateApprovalFeedbacksDto) {
    return this.put<IMessageResponseDto, IUpdateApprovalFeedbacksDto>(
      `approval-feedbacks/${id}`,
      dto,
    )
  }

  removeApprovalFeedbacks(ids: string[]) {
    return this.delete<IMessageResponseDto>(`approval-feedbacks/`, { data: { ids } })
  }
}

export const approvalFeedbacksService = new ApprovalFeedbacksService()
